var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M14.167 17.0827H5.83366C3.33366 17.0827 1.66699 15.8327 1.66699 12.916V7.08268C1.66699 4.16602 3.33366 2.91602 5.83366 2.91602H14.167C16.667 2.91602 18.3337 4.16602 18.3337 7.08268V12.916C18.3337 15.8327 16.667 17.0827 14.167 17.0827Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    fill: "#E8F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M3.75 8.95833C3.40833 8.95833 3.125 8.675 3.125 8.33333V7.08333C3.125 5.59167 4.34167 4.375 5.83333 4.375H7.08333C7.425 4.375 7.70833 4.65833 7.70833 5C7.70833 5.34167 7.425 5.625 7.08333 5.625H5.83333C5.03333 5.625 4.375 6.28333 4.375 7.08333V8.33333C4.375 8.675 4.09167 8.95833 3.75 8.95833Z",
    fill: "#E8F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M16.2503 8.95833C15.9087 8.95833 15.6253 8.675 15.6253 8.33333V7.08333C15.6253 6.28333 14.967 5.625 14.167 5.625H12.917C12.5753 5.625 12.292 5.34167 12.292 5C12.292 4.65833 12.5753 4.375 12.917 4.375H14.167C15.6587 4.375 16.8753 5.59167 16.8753 7.08333V8.33333C16.8753 8.675 16.592 8.95833 16.2503 8.95833Z",
    fill: "#E8F0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M7.08333 15.6243H5.83333C4.34167 15.6243 3.125 14.4077 3.125 12.916V11.666C3.125 11.3243 3.40833 11.041 3.75 11.041C4.09167 11.041 4.375 11.3243 4.375 11.666V12.916C4.375 13.716 5.03333 14.3743 5.83333 14.3743H7.08333C7.425 14.3743 7.70833 14.6577 7.70833 14.9993C7.70833 15.341 7.425 15.6243 7.08333 15.6243Z",
    fill: "#E8F0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M14.167 15.6243H12.917C12.5753 15.6243 12.292 15.341 12.292 14.9993C12.292 14.6577 12.5753 14.3743 12.917 14.3743H14.167C14.967 14.3743 15.6253 13.716 15.6253 12.916V11.666C15.6253 11.3243 15.9087 11.041 16.2503 11.041C16.592 11.041 16.8753 11.3243 16.8753 11.666V12.916C16.8753 14.4077 15.6587 15.6243 14.167 15.6243Z",
    fill: "#E8F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney4);
export default __webpack_public_path__ + "static/media/money-4.738346df97a82e15a4a3dad5eb787fe6.svg";
export { ForwardRef as ReactComponent };